import classNames from 'classnames'
import { useState, useRef } from 'react'
import Button from '../../../components/Button'
import Card from '../../../components/Card'
import Input from '../Input'


export default function IntroductionStep({ onSubmit }) {
  let formRef = useRef(null)

  let [data, setData] = useState({
    name: '',
    email: '',
    intro: ''
  })

  let valid = data.name && data.email && data.intro

  return (
    <div className='flex flex-col w-full h-full items-center justify-center'>
      <Card withGradient>

        <form className='px-24 py-12 flex text-white gap-24 items-center' ref={formRef}>
          <div className='flex flex-col gap-4 w-72 items-start'>
            <div className='text-2xl font-bold'>
              Wir freuen uns dich kennenlernen! ツ
            </div>
            <div className='text-neutral-500 text-lg'>
              Trage kurz deine Daten ein und erzähle in 1-2 Worten deine Geschichte.
            </div>
            <Button
              type='submit'
              variant='secondary'
              className='text-primary'
              disabled={!valid}
              onClick={(event) => {
                if (formRef.current && formRef.current.reportValidity()) {
                  onSubmit(data)
                }
              }}
            >
              <strong className={classNames('px-12 font-bold', valid && 'text-primary')}>Weiter</strong>
            </Button>
          </div>

          <div className='flex flex-col gap-6'>
            <Input
              title='Dein Name'
              value={data.name}
              required
              onChange={(e) => setData({ ...data, name: e.target.value })}
            />
            <Input
              title='Dein Mail'
              type='email'
              value={data.email}
              required
              onChange={(e) => setData({ ...data, email: e.target.value })}
            />
            <div className='rounded-lg border border-primary bg-background px-4 py-3 text-sm font-semibold text-primary' role='alert'>
              Hinweis: Diese E-Mail-Adresse brauchst du später auch für den Login.
            </div>
            <Input
              title='Kurzes Intro'
              type='textarea'
              required
              value={data.intro}
              className='resize-none'
              onChange={(e) => setData({ ...data, intro: e.target.value })}
            />
          </div>
        </form>
      </Card>
    </div>
  )
}
